import { render, staticRenderFns } from "./mybizdevice.vue?vue&type=template&id=560581a6"
import script from "./mybizdevice.vue?vue&type=script&lang=js"
export * from "./mybizdevice.vue?vue&type=script&lang=js"
import style0 from "./mybizdevice.vue?vue&type=style&index=0&id=560581a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports